import { type ReactNode, type TransitionEventHandler, type Ref } from 'react'
import cx from 'classnames'
import styles from './FullscreenOverlay.module.css'
import { Portal } from '@/components/Portal'

export interface FullscreenOverlayProps {
  showing: boolean
  preventScroll?: boolean
  children?: ReactNode
  onTransitionEnd?: TransitionEventHandler
  ref?: Ref<HTMLDivElement>
}

/**
 * A dimmed layer over the whole viewport that hosts modal content.
 */
export function FullscreenOverlay({
  showing,
  children,
  preventScroll,
  onTransitionEnd,
  ref,
}: FullscreenOverlayProps) {
  return (
    <Portal>
      <div
        className={cx(
          styles.root,
          !showing && styles.hidden,
          preventScroll && styles.preventScroll,
        )}
        onTransitionEnd={onTransitionEnd}
        ref={ref}
      >
        <div className={styles.background} />
        {children}
      </div>
    </Portal>
  )
}
